// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._181u1kdv{-webkit-user-select:text}\n._1rkw1kdv{-moz-user-select:text}\n._1ul9idpf{min-width:0}\n._syazi7uo{color:var(--ds-text,#292a2e)}\n._te171kdv{-ms-user-select:text}\n._uizt1kdv{-webkit-user-select:text;-ms-user-select:text;user-select:text}", ""]);
// Exports
module.exports = exports;
